export default "__VITE_ASSET__c6ba9fc3__"